import React, { useState } from 'react'
import styles from './styles.module.css'
import { getIcon } from '../../assets/getIcon'
import UploadCom from './components/uploadCom'
import Analysis from './components/analysis'
import { analysisExcel } from './excelTool'
import { Spin, message } from 'antd'

export default function UploadEl(props) {
  // const isPro = process.env.NODE_ENV === 'production'
  const { templatePath } = props
  const [status, setStatus] = useState('upload') // upload 上传  analysis 分析 done 完成
  const [analysisData, setanalysisData] = useState({
    percent: 0,
    errorNum: 0,
    rowNum: 0
  })
  const [bufferData, setBufferData] = useState(null)
  const [fileData, setFileData] = useState(null)
  const [loading, setLoading] = useState(false)

  function downloadTemplate(url, name) {
    const a = document.createElement('a')
    a.href = `${url}`
    a.target = '_blank'
    a.download = name
    document.body.appendChild(a)
    a.click()
  }

  function uploadFucHandle(data) {
    console.log('uploadFucHandle', data)
    setLoading(true)
    analysisExcel(data, (percent, errorNum, rowNum) => {
      if (status === 'upload') {
        setStatus('analysis')
        setLoading(false)
      }
      if (percent === 100) {
        setStatus('done')
      }
      setanalysisData({
        percent: parseInt(percent),
        errorNum,
        rowNum
      })
    })
      .then((res) => {
        console.log('analysisExcel', res)
        setBufferData(res)
        setFileData(data)
      })
      .catch((e) => {
        console.log('analysisExcelerror', e)
        setLoading(false)
        message.error('解析错误')
      })
  }

  function getTitle() {
    const obj = {
      upload: '导入数据',
      analysis: '校验和计算',
      done: '导出结果'
    }
    return obj[status]
  }

  function reload() {
    setStatus('upload')
    setanalysisData({
      percent: parseInt(0),
      errorNum: 0,
      rowNum: 0
    })
  }

  function getBtn() {
    const obj = {
      upload: (
        <a>
          <div
            onClick={() => {
              downloadTemplate(templatePath, '数据模板.xlsx')
            }}
            className={styles.zhyl_ckd_upload_title_p_right}
          >
            <img
              className={styles.zhyl_ckd_upload_img}
              src={getIcon('mbicon2x')}
            />
            <span className={styles.zhyl_ckd_upload_huoqv}>获取模板</span>
          </div>
        </a>
      ),
      analysis: '',
      done: (
        <a>
          <div
            onClick={reload}
            className={styles.zhyl_ckd_upload_title_p_right}
          >
            <img
              className={styles.zhyl_ckd_upload_img}
              src={getIcon('Reload2x')}
            />
            <span className={styles.zhyl_ckd_upload_huoqv}>重新导入数据</span>
          </div>
        </a>
      )
    }
    return obj[status]
  }

  return (
    <Spin spinning={loading} wrapperClassName='page-loading'>
      <div className={styles.zhyl_ckd_upload}>
        <div className={styles.zhyl_ckd_upload_title}>
          <p className={styles.zhyl_ckd_upload_title_p}>{getTitle()}</p>
          {getBtn()}
        </div>
        {status === 'upload' ? (
          <UploadCom
            uploadFucHandle={uploadFucHandle}
            style={{ marginTop: '32px' }}
          />
        ) : (
          <Analysis
            fileData={fileData}
            status={status}
            style={{ marginTop: '48px' }}
            analysisData={analysisData}
            bufferData={bufferData}
          />
        )}
      </div>
    </Spin>
  )
}
